import React from "react"
import { Container, Row, Col } from "@bootstrap-styled/v4"
import { StaticQuery, graphql } from "gatsby"
import { Element } from "react-scroll"
import WOW from "react-wow"

import Button from "src/components/ui/Button"
import PortfolioItem from "../../ui/PortfolioItem"

import * as S from "./styled"

const PortfolioDestaques = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          divisorImg: file(relativePath: { eq: "trumps/lotus-y.png" }) {
            childImageSharp {
              fluid(maxWidth: 80) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          content: allMarkdownRemark(
            filter: { fileAbsolutePath: { regex: "/(projects)/.*.md$/" } }
            limit: 4
            sort: { fields: frontmatter___date, order: DESC }
          ) {
            edges {
              node {
                fields {
                  slug
                }
                frontmatter {
                  title
                  category
                  image {
                    childImageSharp {
                      fluid(maxWidth: 450) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={data => (
        <Element name="section-portfolio">
          <S.PortfolioDestaquesWrapper>
            <Container>
              <S.PortfolioDestaquesHeader>
                <WOW animation="fadeInUp">
                  <S.PortfolioDestaquesDesc>
                    {`Você também pode gostar...`}
                  </S.PortfolioDestaquesDesc>
                  <S.PortfolioDestaquesTitle>
                    {`Projetos em destaque`}
                  </S.PortfolioDestaquesTitle>
                </WOW>
              </S.PortfolioDestaquesHeader>
            </Container>
            <S.PortfolioDestaquesContent>
              <Container>
                <Row>
                  {data.content.edges.map((item, i) => (
                    <WOW animation="fadeIn" key={i}>
                      <Col xs={12} lg={6}>
                        <PortfolioItem
                          slug={item.node.fields.slug}
                          title={item.node.frontmatter.title}
                          category={item.node.frontmatter.category}
                          img={item.node.frontmatter.image}
                        />
                      </Col>
                    </WOW>
                  ))}
                </Row>
                <WOW animation="zoomIn">
                  <S.PortfolioDestaquesMore to="/portfolio">
                    <Button hasIconAfter="CardList" color="primary" size="lg">
                      Ver mais projetos
                    </Button>
                  </S.PortfolioDestaquesMore>
                </WOW>
              </Container>
            </S.PortfolioDestaquesContent>
          </S.PortfolioDestaquesWrapper>
        </Element>
      )}
    />
  )
}

export default PortfolioDestaques
